import { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { useThreadsStore } from '@lib/store';
import { SendMessage, ThreadTile } from './widgets';

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    alignItems: 'flex-start',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '24px',
    width: '100%',
  },
  threads: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    gap: theme.spacing(2),
    margin: 0,
    padding: 0,
  },
  list: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    gap: theme.spacing(2),
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  spinner: {
    display: 'black',
    margin: 'auto',
  },
}));

export const MessagesPage = () => {
  const { loading, data: threads, getThreads, deleteThread, markAsRead } = useThreadsStore();

  const styles = useStyles();

  useEffect(() => {
    getThreads();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.threads}>
        {loading && <CircularProgress className={styles.spinner} />}
        {!loading && (
          <ul className={styles.list}>
            {threads.map((item) => (
              <ThreadTile
                key={item.groupId}
                id={item.groupId}
                groupId={item.groupId}
                date={item.lastCreatedOn}
                subject={item.subject}
                allRead={item.allRead}
                from={item.userName}
                to={item.receiverName}
                replyReceiverId={item.replyReceiverId}
                onRemove={deleteThread}
                onMarkAsRead={markAsRead}
              />
            ))}
          </ul>
        )}
      </div>
      <SendMessage onSubmit={getThreads} />
    </div>
  );
};
